// @generated by protoc-gen-es v1.6.0 with parameter "target=js"
// @generated from file dymensionxyz/dymension/lockup/tx.proto (package dymensionxyz.dymension.lockup, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Duration, proto3 } from "@bufbuild/protobuf";
import { Coin } from "./coin_pb.js";
import { PeriodLock } from "./lock_pb.js";

/**
 * @generated from message dymensionxyz.dymension.lockup.MsgLockTokens
 */
export const MsgLockTokens = proto3.makeMessageType(
  "dymensionxyz.dymension.lockup.MsgLockTokens",
  () => [
    { no: 1, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "duration", kind: "message", T: Duration },
    { no: 3, name: "coins", kind: "message", T: Coin, repeated: true },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.lockup.MsgLockTokensResponse
 */
export const MsgLockTokensResponse = proto3.makeMessageType(
  "dymensionxyz.dymension.lockup.MsgLockTokensResponse",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.lockup.MsgBeginUnlockingAll
 */
export const MsgBeginUnlockingAll = proto3.makeMessageType(
  "dymensionxyz.dymension.lockup.MsgBeginUnlockingAll",
  () => [
    { no: 1, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.lockup.MsgBeginUnlockingAllResponse
 */
export const MsgBeginUnlockingAllResponse = proto3.makeMessageType(
  "dymensionxyz.dymension.lockup.MsgBeginUnlockingAllResponse",
  () => [
    { no: 1, name: "unlocks", kind: "message", T: PeriodLock, repeated: true },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.lockup.MsgBeginUnlocking
 */
export const MsgBeginUnlocking = proto3.makeMessageType(
  "dymensionxyz.dymension.lockup.MsgBeginUnlocking",
  () => [
    { no: 1, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ID", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "coins", kind: "message", T: Coin, repeated: true },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.lockup.MsgBeginUnlockingResponse
 */
export const MsgBeginUnlockingResponse = proto3.makeMessageType(
  "dymensionxyz.dymension.lockup.MsgBeginUnlockingResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "unlockingLockID", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * MsgExtendLockup extends the existing lockup's duration.
 * The new duration is longer than the original.
 *
 * @generated from message dymensionxyz.dymension.lockup.MsgExtendLockup
 */
export const MsgExtendLockup = proto3.makeMessageType(
  "dymensionxyz.dymension.lockup.MsgExtendLockup",
  () => [
    { no: 1, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ID", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "duration", kind: "message", T: Duration },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.lockup.MsgExtendLockupResponse
 */
export const MsgExtendLockupResponse = proto3.makeMessageType(
  "dymensionxyz.dymension.lockup.MsgExtendLockupResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * MsgForceUnlock unlocks locks immediately for
 * addresses registered via governance.
 *
 * @generated from message dymensionxyz.dymension.lockup.MsgForceUnlock
 */
export const MsgForceUnlock = proto3.makeMessageType(
  "dymensionxyz.dymension.lockup.MsgForceUnlock",
  () => [
    { no: 1, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ID", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "coins", kind: "message", T: Coin, repeated: true },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.lockup.MsgForceUnlockResponse
 */
export const MsgForceUnlockResponse = proto3.makeMessageType(
  "dymensionxyz.dymension.lockup.MsgForceUnlockResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

